import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AddFunctii, UpdateFunctii } from './functii.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FunctiiService {
  private token!: string;
  private httpOptions: any;

  private basePath = environment.interop.basePath;
  private getFunctiiUrl =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.functie.getFunctii;
  private getFunctiiDT =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.functie.getFunctii;
  private storeFunctii =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.functie.storeFunctie;
  private updateFunctii =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.functie.putFunctie;
  private deleteFunctii =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.functie.deleteFunctie;
  private publicFunctii =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.functie.getFunctiiActivePublic;
  private activeFunctii =
    this.basePath +
    environment.interop.autorizatiiComerciale.nomenclatoare.functie.getFunctiiActive;

  constructor(private http: HttpClient) {}

  getFunctii() {
    return this.http.get(this.getFunctiiDT, this.httpOptions);
  }

  addFunctii(functii: AddFunctii) {
    return this.http.post(this.storeFunctii, functii, this.httpOptions);
  }

  updateFunctiiData(functii: UpdateFunctii) {
    return this.http.put(this.updateFunctii, functii, this.httpOptions);
  }

  deleteFunctiiData(functii: number) {
    return this.http.delete(this.deleteFunctii + functii);
  }

  activeFunctiiData() {
    return this.http.get(this.activeFunctii, this.httpOptions);
  }
  publicFunctiiData() {
    return this.http.get(this.publicFunctii, this.httpOptions);
  }

  getMappedFunctii() {
    return this.http
      .get<{ errors: boolean; data: any[]; status_code: number }>(
        this.getFunctiiUrl
      )
      .pipe(
        map((response) =>
          response.data.map((item) => ({
            id: item.id,
            name: item.name,
          }))
        ),
        catchError((error) => {
          console.error('Error in get functii:', error);
          return throwError(error);
        })
      );
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
